import styles from "./styles.module.scss";

const FormSelect = ({ label, value, onChange, options }) => (
  <div className={styles.formGroup}>
    <label className={styles.formLabel}>{label}</label>
    <div className={styles.formSelectWrapper}>
      <select value={value} onChange={onChange} className={styles.formSelect}>
        <option value="">Select {label}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default FormSelect;
